module.exports = __webpack_public_path__ + "static/media/logo.c3ae0c43.png";